// Create 1 store for the entire web app
//		1. thunk 	= for async request
//		2. logger = for logging prev state, action & next state
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers'
import { authMiddleware } from '../middleware';

import { loadingBarMiddleware } from 'react-redux-loading-bar'
import promiseMiddleware from 'redux-promise-middleware';
import { logger } from 'redux-logger'
const middlewares = [thunk, promiseMiddleware(), loadingBarMiddleware(), authMiddleware];

if (process.env.NODE_ENV === `development`) {
  // const { logger } = require(`redux-logger`);
  middlewares.push(logger);
}
const createStoreWithMiddleware = compose(
    applyMiddleware(...middlewares),
  )(createStore);

const store = createStoreWithMiddleware(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export default store;